import { VNode } from 'vue'
import { Component } from 'vue-property-decorator'
import PortalController from './controller'
import SysHeader from '@/components/header/view'
import AppItem from '@/components/app-item/view'
import { Checkbox, Dialog, Button, Popover } from 'element-ui'
import Draggable from 'vuedraggable'

import $style from './index.module.scss'
import { NoticeItem } from '@/model/definitions'
import dayjs from 'dayjs'

@Component({
  components: {
    SysHeader,
    AppItem,
    Draggable,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    [Popover.name]: Popover
  }
})
export default class extends PortalController {
  renderDialog(): VNode {
    return (
      <el-dialog
        title="帐户安全提醒"
        visible={this.showDialog}
        onClose={() => {
          this.showDialog = false
        }}
      >
        <div class={$style.inner_dialog}>
          <div class="line-01">Moka People登陆注意事项</div>
          <div class="line-02">登录账号:企业的个人邮箱( xx.xxx@visionacademy.cn )</div>
          <div class="line-03">账户密码: <span>无初始密码,首次登录点击【新用户】直接设置密码;</span></div>
          {/* <div class="line-04">
            系统密码强制更新周期为180天，如出现“密码失效”、“锁定”等提示，可在唯寻EHR登陆页面中点击“<span>忘记密码</span>”进行重置。
          </div> */}
          <div class="footer-btn">
            <el-button type="primary" onClick={() => {
              window.open('https://core.mokahr.com/')
              this.showDialog = false
            }}>前往Moka People</el-button>
          </div>
        </div>
      </el-dialog>
    )
  }

  renderNotice(): VNode {
    return (
      <div class="notice-list">
        {
          this.notices.length
            ? this.notices.map((not: NoticeItem, index: number) => (
              <div class="notice-item">
                <span>{ index + 1 }</span>
                <el-popover
                  placement="top"
                  width="450"
                  trigger="click">
                  <div style="padding: 10px;">
                    <div style="font-size: 16px;color:#333;font-weight:500;padding:0 0 15px;">{ not.title }</div>
                    <div>
                      {
                        not.notice.map(n => (
                          <div style="padding:0 0 15px;">
                            <div style="display: inline-block; color: #666;">
                              { n.title && <span style="font-weight: 500;display: inline-block;color: #333;">{ n.title }</span> }
                              { n.txt }
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                  <div class="clickabel" slot="reference">
                    { not.title && (<div class="item-title">{ not.title }</div>) }
                    { not.notice.map(n => (n.title || '') + n.txt).join('') }
                  </div>
                </el-popover>
                <span>{ dayjs(not.date).format('YYYY年MM月DD日') }</span>
              </div>
            )) : (
              <div class='empty-apps'>
                <div class='empty-icon'></div>
                <span>暂无任何通知</span>
              </div>
            )
        }
      </div>
    )
  }

  render(): VNode {
    return <div class={$style.portal_viewport}>
      <sys-header onSearch={this.doSearch}></sys-header>
      <div class="page-content">
        <div class="welcome">
          <div class="logo"></div>
          <div class="text">
            <div class="wel-with-name">Hi~~ {this.userInfo?.realName || '-'} 您好，欢迎访问唯寻教育大中台。今天是{this.today}</div>
            <div class="words">{this.aWord}</div>
          </div>
        </div>

        <div class="my-apps">
          <div class="title">
            <div class="title-left">
              <div class="my-app-logo"></div>
              我的应用
              <span>我已经获得权限的应用</span>
            </div>
            <div class="btn-order" onClick={this.triggerDrag}>
              <i></i>
              {`${this.dragable ? '完成排序' : '自定义排序'}`}
            </div>
          </div>

          <section>
            <div class="app-list">
              {
                this.myApps.length
                  ? <draggable draggable=".draggable" tag="section" v-model={this.myApps} options={this.draggableCfg} onEnd={this.dragEnd}>
                    {
                      this.myApps.map(app => {
                        const delay = Math.floor(Math.random() * 4)
                        return <app-item
                          props={{ model: app }}
                          onClick={this.appClick}
                          onFav={this.appFav}
                          class={`${this.dragable ? `draggable drag-delay-${delay}` : ''}`}/>
                      })
                    }
                  </draggable>
                  : (
                    <div class='empty-apps'>
                      <div class='empty-icon'></div>
                      <span>未找到指定的应用</span>
                    </div>
                  )
              }
            </div>
          </section>
        </div>

        <div class="hr-module">
          <div class="hr-apps">
            <header>
              <div class="head-title">
                <div class="icon-for-title icon-hr" />
                <span>人事模块</span>
              </div>
              <div class="">
                <el-checkbox v-model={this.closeTip}>关闭提醒事项</el-checkbox>
              </div>
            </header>
            <div class="hr-app-layout">
              <div class="hal-left">
                {
                  this.hrApps.map(app => (
                    <app-item props={{ model: app }} onClick={this.appClick} />
                  ))
                }
              </div>
              <div class="hal-right" onClick={this.ehrClick}>
                <div class="hal-right-top">
                  <div class="right-top-icon" />
                  <span>Moka People</span>
                </div>
                <div class="hal-right-bottom">
                  员工自助，人事流程处理<br />
                  (如转正、调岗、调薪与离职申请)
                </div>
              </div>
            </div>
          </div>
          <div class="notices">
            <header>
              <div class="head-title">
                <div class="icon-for-title icon-notice" />
                <span>人事提醒</span>
              </div>
            </header>
            { this.renderNotice() }
          </div>
        </div>

        <div class="oss-apps">
          <div class="title">
            <div class="title-left">
              <div class="my-app-logo"></div>
              我的应用
              <span>接入单点登录,并拥有权限的应用</span>
            </div>
            {
              this.userInfo && this.ssoAppData.length > 1 && (
                <div class="btn-order" onClick={this.triggerSSODrag}>
                  <i></i>
                  {`${this.ssoDragable ? '完成排序' : '自定义排序'}`}
                </div>
              )
            }
          </div>
          <section>
            <div class="app-list">
              {
                this.ssoAppData.length
                  ? <draggable draggable=".draggable-sso" tag="section" v-model={this.ssoAppData} onEnd={this.ssoDragEnd}>
                    {
                      this.ssoAppData.map(app => {
                        const delay = Math.floor(Math.random() * 4)
                        return <app-item
                          props={{ model: app }}
                          onClick={this.appClick}
                          class={`${this.ssoDragable ? `draggable-sso drag-delay-${delay}` : ''}`}/>
                      })
                    }
                  </draggable>
                  : (
                    <div class='empty-apps'>
                      <div class='empty-icon'></div>
                      <span>
                        {
                          this.token
                            ? '您的帐号没有任何应用的权限, 请联系管理员为您开通'
                            : <div>
                              <em>您还没有登录, 请点击<a href='/login'>去登录</a></em>
                              <div class="important-tip">使用现有工作台的老师请忽略, 按原有方式使用即可!</div>
                            </div>
                        }
                      </span>
                    </div>
                  )
              }
            </div>
          </section>
        </div>

        <div class="all-apps">
          <div class="title">
            <div class="all-apps-logo"></div>
            全部应用
          </div>
          <div class="app-list">
            {
              this.appData.map(app => {
                return <app-item canFav={false} props={{ model: app }} disable size='small'></app-item>
              })
            }
          </div>
        </div>
      </div>
      { this.renderDialog() }
    </div>
  }
}
